export default __webpack_public_path__ + "static/media/import-center.509a4c97.png";